import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthRoles implements CanActivate {
  constructor(private navigation: NavigationService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    const storedRoles = localStorage.getItem('role');
    const roles = storedRoles
      ? storedRoles.split(',').map(r => r.trim()).filter(Boolean)
      : this.navigation.role
      ? this.navigation.role.toString().split(',').map(r => r.trim())
      : [];

    const baseAllowed = [
      'admin',
      'coordenador',
      'solubio',
      'franchise',
      'laboratorio',
    ];

    // Clientes podem acessar Laudos, mas continuam bloqueados para as demais rotas protegidas por este guard
    const allowedRoles = state.url.startsWith('/reports')
      ? [...baseAllowed, 'cliente']
      : baseAllowed;

    const isAuthorized = roles.some(role => allowedRoles.includes(role));

    if (isAuthorized) {
      return true;
    }

    this.router.navigate(['']);

    alert('Você não tem autorização para acessar essa página');
    return false;
  }
}
